import React from 'react';
import { Typography, Stack } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Chip from '@mui/material/Chip';

const UserInformation = ({ user, loading }: { user: any; loading: boolean }) => {
  return (
    <Stack spacing={4}>
      <Card>
        <CardContent>
          <Typography sx={{ fontSize: '14px' }} color="text.secondary" gutterBottom>
            Email
          </Typography>
          <Typography variant="h5" component="div"></Typography>
          <Typography sx={{ mb: 1.5 }} color="text.secondary">
            {user?.email}
          </Typography>
          <Typography sx={{ fontSize: '14px' }} color="text.secondary" gutterBottom>
            CEE Person ID
          </Typography>
          <Typography variant="h5" component="div"></Typography>
          <Typography sx={{ mb: 1.5 }} color="text.secondary">
            {user?.uid}
          </Typography>
          <Typography sx={{ fontSize: '14px' }} color="text.secondary" gutterBottom>
            Person ID
          </Typography>
          <Typography variant="h5" component="div"></Typography>
          <Typography sx={{ mb: 1.5 }} color="text.secondary">
            {user?.personId}
          </Typography>
          <Typography sx={{ fontSize: '14px' }} color="text.secondary" gutterBottom>
            Authentication User Id
          </Typography>
          <Typography variant="h5" component="div"></Typography>
          <Typography sx={{ mb: 1.5 }} color="text.secondary">
            {user?.authenticationUserId}
          </Typography>
        </CardContent>
      </Card>
      <Card>
        <CardContent>
          <Typography sx={{ fontSize: '14px' }} color="text.secondary" gutterBottom>
            Debug Mode
          </Typography>
          <Typography color="text.secondary">
            {user?.debug === true ? (
              <Chip label="På" color="success" />
            ) : (
              <Chip label="Avstängt" color="error" />
            )}
          </Typography>
        </CardContent>
      </Card>
    </Stack>
  );
};

export default UserInformation;
